import { languages as constantsLanguage } from '@/common/constants'
import { isHtmlContentEmpty } from '@/common/helpers/helpers'

export const isStepEmpty = step => {
  const text = step?.text
  if (text === null || text === undefined || text === '') return true
  if (typeof text !== 'string') return false
  return isHtmlContentEmpty(text)
}

export const getLanguagesWithStatus = (languages, steps, t) => {
  const availableLanguages = constantsLanguage(t).filter(lang => languages?.includes(lang.value))

  const maxSteps = Math.max(0, ...availableLanguages.map(lang => steps[lang.value]?.length || 0))

  const checkLangError = availableLanguages.map(lang => {
    const langSteps = steps[lang.value] || []
    const hasEmptyStep = langSteps.some(step => isStepEmpty(step))
    const hasMissingSteps = langSteps.length < maxSteps

    if (hasEmptyStep || hasMissingSteps) {
      return { ...lang, error: true }
    }
    return lang
  })

  return checkLangError
}
